// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2aXys","selected":"Chip_selected__10vxB"};